import type { ReactNode } from "react";

interface DetailPanelProps {
	children: ReactNode;
	title: string;
}

export const DetailPanel = ({ children, title }: DetailPanelProps) => (
	<section className="rounded-md border border-secondary p-4">
		<h3 className="mb-3 text-sm font-semibold text-primary">{title}</h3>
		{children}
	</section>
);

interface KeyValueListProps {
	items: { label: string; value: ReactNode }[];
}

export const KeyValueList = ({ items }: KeyValueListProps) => (
	<dl className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-1 text-sm">
		{items.map((item) => (
			<div className="contents" key={item.label}>
				<dt className="text-tertiary">{item.label}</dt>
				<dd className="text-primary">{item.value}</dd>
			</div>
		))}
	</dl>
);
